export default "__VITE_PUBLIC_ASSET__067cf5dd__"